import { render, staticRenderFns } from "./TemplateCreate.vue?vue&type=template&id=6d838e34&scoped=true"
import script from "./TemplateCreate.vue?vue&type=script&lang=js"
export * from "./TemplateCreate.vue?vue&type=script&lang=js"
import style0 from "./TemplateCreate.vue?vue&type=style&index=0&id=6d838e34&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d838e34",
  null
  
)

export default component.exports